import { z } from 'zod';

export const UpdateDtSchema = z.object({
    data: z.record(z.string(), z.unknown()).describe("L'objet complet contenant les nouvelles données du DT (compétences, expériences, etc.)"),
    referenceDtId: z.string().nullish().describe('ID du DT de référence'),
    comment: z.string().nullish().describe('Commentaire de révision lié à cette mise à jour'),
});

export type UpdateDtDto = z.infer<typeof UpdateDtSchema>;